<template>
  <div class="elCard">
    <div class="header">
      <i class="el-icon-arrow-left" @click="goBack()"></i>
      <div class="img"><img :src="baseUrl + zsInfo.avatarCN" alt="" /></div>
      <span class="name">{{ zsInfo.companyNameC }}</span>
    </div>
    <div class="content" ref="content" v-if="messageLists.length">
      <div class="firstTime">{{ firstTime }}</div>
      <div v-for="(item, index) in messageLists" :key="index" class="item">
        <div v-if="item.sendType === 0" class="sendType1">
          <!-- 观众发给展商的 0-->
          <span class="content1" v-html="item.content">{{ item.content }}</span>
          <span class="img1">
            {{ name }}
          </span>
        </div>

        <div v-else class="sendType2">
          <!-- 展商发给观众的 1 -->
          <span class="img2">
            <img :src="baseUrl + zsInfo.avatarCN" alt="" />
          </span>
          <span class="content2" v-html="item.content">{{ item.content }}</span>
        </div>
      </div>
    </div>

    <div class="footer">
      <!-- <tinymce id="myedit" ref="sendMessage" class="tinymce" :data="data"></tinymce> -->
      <div class="sendMessage">
        <el-upload
          ref="upload"
          class="upload-demo"
          :action="baseUrl + '/hz/frontCommon/upload'"
          :headers="getToken()"
          :on-error="handleError"
          :on-success="handleSuccess"
          :show-file-list="false"
        >
          <div class="el-icon-picture"></div>
          {{ $t('mobile.sendImg') }}
        </el-upload>

        <textarea v-model="data" name="" id="" cols="30" rows="10" class="input" :placeholder="$t('mobile.input')"></textarea>
      </div>
      <div class="button" @click="send()">{{ $t('mobile.send') }}</div>
    </div>
  </div>
</template>
<script>
import { getMessage, getzsMessage, sendMessage } from '../.././../api/message.js';
import { forMat } from '../../../utils/common.js';
import Tinymce from '../../views/comment/tinymce.vue';
import { getInfo } from '../../../api/personInfo.js';
export default {
  data() {
    return {
      baseUrl: forMat(),
      sendUserId: '',
      receiveUserId: this.$route.query.receiveUserId,
      zsInfo: {
        avatarCN: '',
        companyNameC: '',
      },
      messageLists: [],
      name: '',
      firstTime: '',
      value: '',
      data: '',
      arrLength: '',
      i: 0,
    };
  },
  components: {
    Tinymce,
  },
  created() {
    this.getUserInfo();
    this.getzsInfo();
  },
  watch: {
    i(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal !== oldVal) {
        this.scrollEnd();
      }
    },
  },
  methods: {
    scrollEnd() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
        }, 2000);
      });
    },

    async getUserInfo() {
      try {
        const { data } = await getInfo();
        if (data.code === 200) {
          const str = data.data.name;
          this.name = str.slice(-1);
          this.sendUserId = data.data.id;
          this.getMessages();
        }
      } catch (err) {}
    },

    async send() {
      const params = {
        content: this.data,
        receiveUserId: this.receiveUserId,
        msgType: this.data.includes('img') ? '1' : '0',
      };
      try {
        const { data } = await sendMessage(params);
        if (data.code === 200) {
          this.getMessages();
          this.data = '';
        }
      } catch (err) {
        console.log(err.msg);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
    // 获取展商信息
    async getzsInfo() {
      const params = {
        id: this.receiveUserId,
      };
      try {
        const { data } = await getzsMessage(params);
        if (data.code === 200) {
          this.zsInfo = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    // 获取聊天记录
    async getMessages() {
      const params = {
        sendUserId: this.sendUserId,
        receiveUserId: this.receiveUserId,
      };
      try {
        this.i = 0;
        const { data } = await getMessage(params);
        if (data.code === 200) {
          this.messageLists = data.data;
          this.i = 1;
          if (this.messageLists.length < 1) {
            this.send('你好');
          } else {
            this.firstTime = this.messageLists[0].time;
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    //获取token
    getToken() {
      const a = localStorage.getItem('viewToken');
      let token = {};
      token.token = a;
      return token;
    },
    handleError(file) {
      console.log(file, '上传图片失败');
    },
    handleSuccess(file) {
      console.log('上传成功', file);
      let url = this.baseUrl + file.data.url;
      let img = `<img src=${url} alt="">`;
      this.sendImg(img);
    },
    async sendImg(data) {
      const params = {
        content: data,
        receiveUserId: this.receiveUserId,
        msgType: data.includes('img') ? '1' : '0',
      };
      const that = this;
      try {
        const { data } = await sendMessage(params);
        if (data.code === 200) {
          this.getMessages();
          this.data = '';
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.elCard {
  margin-top: 50px;
  padding-top: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 0 20px 20px ;
  box-sizing: border-box;
  background: #FFFFFF;
  overflow-y: scroll;
  .header {
    height: 68px;
    border-bottom: 1px solid #e8e8e8;
    padding: 17px 0px;
    box-sizing: border-box;
    line-height: 68px;
    display: flex;
    cursor: pointer;
    i {
      line-height: 32px;
      margin-right: 10px;
    }
    .img {
      width: 66px;
      text-align: center;
      background: white;
      border: 1px solid #e0e0e0;
      line-height: 33px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 60px;
        max-height: 33px;
      }
    }

    .name {
      flex: 1;
      line-height: 16px;
      margin-left: 10px;
 
      display: flex;
      align-items: center;
    }
  }
  .content {
    height: calc(100vh - 243px);
    height: -webkit-calc(100vh - 243px);
    overflow: scroll !important;
    // overflow-y: scroll;
    padding-top: 40px;
    padding-bottom: 40px;
    box-sizing: border-box;
    position: relative;
    display: block !important;

    .firstTime {
      text-align: center;
    }
    .item {
      margin-top: 10px;
      margin-right: 10px;
      overflow: hidden;
      .sendType1 {
        float: right;
        display: flex;

        .img1 {
          width: 40px;
          height: 40px;
          margin-left: 10px;
          background: #006fb8;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          color: #fff;
        }
        .content1 {
          padding: 10px 10px;
          box-sizing: border-box;
          background: #f1f1f1;
          position: relative;
          width: fit-content;
          margin: 0 auto;

          img {
            display: block;
            max-width: 200px;
            height: 200px;
          }
        }
        .content1::after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          right: -10px;
          top: 10px;
          border: 5px solid;
          border-color: transparent transparent transparent #f1f1f1;
        }
      }
      .sendType2 {
        float: left;
        display: flex;
        .img2 {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          border: 1px solid #e0e0e0;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 40px !important;
            max-height: 40px !important;
            border-radius: 20px !important;
          }
        }
        .content2 {
          padding: 10px 10px;
          box-sizing: border-box;
          background: #fdd000;
          position: relative;
          width: fit-content;
          margin: 0 auto;
          display: block !important;
          img {
            display: block !important;
            max-width: 200px !important;
            height: 200px !important;
          }
        }
        .content2::before {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          left: -10px;
          top: 10px;
          border: 5px solid;
          border-color: transparent #fdd000 transparent transparent;
        }
      }
    }
  }
  .footer {
    height: 125px;
    background: #f7f7f7;
    width: 100%;
    position: relative;
    .input {
      width: 100%;
      height: 62px;
      border: none;
      padding: 10px;
      padding-left: 15px;
      box-sizing: border-box;
      margin: 10px 0px 10px 0px;
      outline: none;
      background: #f7f7f7;
      border-top: 1px solid #e0e0e0;
    }
    textarea::-webkit-input-placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
    .button {
      width: 90px;
      height: 36px;
      background: #006fb8;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 23px;
      text-align: center;
      line-height: 36px;
      border-radius: 6%;
      cursor: pointer;
      position: absolute;
      bottom: 10px;
      right: 15px;
    }
  }
}

.sendMessage {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  padding: 10px 0px 10px 0px;
}
</style>
<style scoped>
.tinymce {
  background: #f7f7f7;
  border-radius: 2px;
}
.tinymce >>> .tox-statusbar {
  display: none;
}
.tinymce >>> .tox-toolbar__primary {
  border: 0;
  background: #f7f7f7;
}
.tinymce >>> .tox-edit-area {
  border: 0;
}
.tinymce >>> .tox-edit-area__iframe {
  background: #f7f7f7 !important;
}
.tinymce >>> .tox-tinymce {
  border: 0;
}
.content2 >>> img {
  width: 100% !important;
  max-height: 100% !important;
  display: block !important;
  margin: 0 auto !important;
}
.content1 >>> img {
  width: 100% !important;
  max-height: 100% !important;
  display: block !important;
  margin: 0 auto !important;
}
.upload-demo {
  padding-left: 15px;
  box-sizing: border-box;
}
</style>
